import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import AdvancedTypography from 'Components/UI/AdvancedTypography';

const AGREEMENT_MAP = {
  termsOfUse: {
    label: 'Terms of Use',
    href: 'https://facetwealth.com/legal-documents/terms-of-use/',
  },
  privacyPolicy: {
    label: 'Privacy Policy',
    href: 'https://facetwealth.com/legal-documents/privacy-policy/',
  },
};

const styles = () => ({
  root: {},
  linkUnderline: {
    textDecoration: 'underline',
  },
});

const AgreementsBlurb = ({
  className,
  classes,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <AdvancedTypography
        className={classes.searchTypeButtonText}
        fragments={[
          {
            weight: 'bold',
            text: 'By using our website, you agree to our ',
          },
          {
            className: classes.linkUnderline,
            innerComponent: 'a',
            color: 'primary',
            bold: true,
            text: AGREEMENT_MAP.termsOfUse.label,
            innerComponentProps: {
              target: '_blank',
              href: AGREEMENT_MAP.termsOfUse.href,
            },
          },
          {
            weight: 'bold',
            text: ' and ',
          },
          {
            className: classes.linkUnderline,
            innerComponent: 'a',
            color: 'primary',
            bold: true,
            text: AGREEMENT_MAP.privacyPolicy.label,
            innerComponentProps: {
              target: '_blank',
              href: AGREEMENT_MAP.privacyPolicy.href,
            },
          },
        ]}
      />
    </Box>
  );
};

AgreementsBlurb.defaultProps = {
  className: '',
};

AgreementsBlurb.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AgreementsBlurb);
